






















































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Role from '@/store/entities/role';
import {TenantInfoExt} from "../../../api/center"
import {appRouters} from '../../../router/router'
@Component
export default class CreateRole extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    @Prop({type:String,default:''}) title:any;
    role:Role=new Role();
    userPermissions: any = []
    get permissions(){
        return this.$store.state.role.permissions
    }
    defaultProps = {
        children: 'children',
        label: 'label'
    }
    created(){
        if(this.title=='编辑'){
            this.role = this.data
        }
        this.getpermissions()
        this.getSelect()
    }
    tenantData:any = [
        {
            label:'所有',
            id: "all",
            children:[],
        }
    ]
    async getSelect(){
        let res = (await TenantInfoExt({}) as any).data
        this.tenantData[0].children = res.map((item:any)=>{
            return {
                id:item.id,
                label:item.name,
                children:[],
            }
        })
    }
    save(){
        (this.$refs.roleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                let nodes = (this.$refs.tree as any).getCheckedNodes()
                let permissions = nodes.map((item:any)=>{
                    return item.id
                })
                //分类出页面权限和操作权限（操作权限内含中文操作名，作为条件）
                this.role.permissions=permissions.filter((item:any)=>{return !/.*[\u4e00-\u9fa5]+.*$/.test(item)})
                let operatings = permissions.filter((item:any)=>{return /.*[\u4e00-\u9fa5]+.*$/.test(item)})
                this.role.optPermissionStr = operatings.join(',')
                //中心
                let tenantnodes = (this.$refs.tenanTree as any).getCheckedNodes()
                let tenantIds = []
                tenantnodes.forEach((item:any)=>{
                    if(item.id !== 'all'){
                        tenantIds.push(item.id)
                    }
                })
                this.role.permissionIds = tenantIds.join(',')
                if(this.title=='新增'){
                    await this.$store.dispatch({
                        type:'role/create',
                        data:this.role
                    });
                }else{
                    await this.$store.dispatch({
                        type:'role/update',
                        data:this.role
                    });
                }
                (this.$refs.roleForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    permissionData:any = [
        {
            label:'所有',
            id: "all",
            children:[],
            subs:[],
        }
    ]
    async getpermissions(){
        let data = await this.$store.dispatch({
            type:'role/getPermissions'
        })
        if(data){
            data.forEach((item,index) => {
                this.permissionData[0].children.push({
                    label:item.displayName,
                    id:item.name,
                    children:[],
                    subs:this.permissionData[0],
                })
                if(item.children && item.children.length>0){
                    item.children.forEach(item_c => {
                        this.permissionData[0].children[index].children.push({
                            label:item_c.displayName,
                            id:item_c.name,
                            children:this.getOperating(item_c.name),
                            subs:this.permissionData[0].children[index],
                        })
                    });
                }else{
                    this.permissionData[0].children[index].children = this.getOperating(item.name)
                }
                
            });
        }
        if(this.title=='编辑'){
            let res =  await this.$store.dispatch({
                type:'role/getRoleForEdit',
                data:{id:this.data.id}
            })
            this.userPermissions = [...res,...this.data.optPermissionStr.split(',')]
        }
    }
    //获取每个页面下的操作权限
    getOperating(permissionName:string){
        //检出所有二级菜单
        let routers = appRouters.map(item=>{
            return item.children
        })
        //二维数组转一唯数组
        let router = routers.reduce(function (a, b) { return a.concat(b)} );
        let operatings:any = router.find((item:any)=>{return item.permission === permissionName})
        if(operatings && operatings.operating){
            return operatings.operating.map((item:any)=>{
                return {
                    label:item,
                    id:permissionName+item,
                    subs:{
                        id:permissionName,
                        children:operatings.operating.map((m:any)=>{
                            return {
                                label:m,
                                id:permissionName+m,
                            }
                        }),
                    },
                    children:[]
                }
            })
        }else{
            return []
        }
        
    }
    setChecks = []
    nodeClick(node:any){
        console.log(node)
        let nodes = (this.$refs.tree as any).getCheckedKeys();
        let indexs = []
        if(!nodes.includes(node.id)){
            nodes.forEach((item,index)=>{
                if(item == node.id) indexs.push(index)
                node.children.forEach(c_item=>{
                    if(item == c_item.id) indexs.push(index)
                    c_item.children.forEach(c2_item=>{
                        if(item == c2_item.id) indexs.push(index)
                        c2_item.children.forEach(c3_item=>{
                            if(item == c3_item.id) indexs.push(index)
                        })
                    })
                })
            })
            let cloneNodes = []
            nodes.forEach((item,index)=>{
                if(!indexs.includes(index)){
                    cloneNodes.push(item)
                }
            })
            nodes = cloneNodes;
        }else{
            nodes.push(node.id)
            node.children.forEach(item=>{
                nodes.push(item.id)
                item.children.forEach(c_item => {
                    nodes.push(c_item.id)
                    c_item.children.forEach(c2_item=>{
                        nodes.push(c2_item.id)
                    })
                });
            })
            let flag = false;
            //如果子集全选中了，设置父级自动选中
            if(node.subs.children){
                node.subs.children.forEach(item=>{
                    if(nodes.includes(item.id)){
                        flag = true
                    }
                })
                if(flag){
                    nodes.push(node.subs.id)
                }
            }
        }
        (this.$refs.tree as any).setCheckedKeys(nodes,nodes.map(v=>{return true}))
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    roleRule={
        name:[{required: true,message:this.L('FieldIsRequired',undefined,this.L('RoleName')),trigger: 'blur'}],
        displayName:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('DisplayName')),trigger: 'blur'}]
    }
}
